import { useContext } from "react";
import { PartnerPageContext } from "../contexts/partnerPageContext";

const usePartnerPageContext = () => useContext(PartnerPageContext);

export { usePartnerPageContext };
